import type { CSSProperties } from 'react';
import { StatusSuccessIcon, StatusWarningIcon } from '@/uicomponents';

const STYLES: Record<string, CSSProperties> = {
  success: { color: 'var(--dz-success)', fontSize: 'var(--dz-font-size-2xl)' },
  error: { color: 'var(--dz-error)', fontSize: 'var(--dz-font-size-2xl)' },
};

interface NotificationIconProps {
  variant: 'success' | 'error';
}

export const NotificationIcon = ({ variant }: NotificationIconProps) => {
  if (variant === 'success') {
    return <StatusSuccessIcon style={STYLES.success} />;
  }
  return <StatusWarningIcon style={STYLES.error} />;
};
